import React, { useContext, useState } from 'react';
import { ModalContext } from '../context/ModalContext';
import '../styles/ConfirmDialog.scss';

export default function ConfirmDialog() {
    const modalContext = useContext(ModalContext);
    const [isExecuting, setIsExecuting] = useState(false);

    if (!modalContext.isConfirmDialogOpen) return null;

    const handleConfirm = async () => {
        setIsExecuting(true);
        try {
            if (modalContext.confirmAction && typeof modalContext.confirmAction === 'function') {
                await modalContext.confirmAction();
            }
        } catch (error) {
            console.error('Error executing confirm action:', error);
        } finally {
            setIsExecuting(false);
            handleCancel();
        }
    };

    const handleCancel = () => {
        modalContext.setIsConfirmDialogOpen(false);
        modalContext.setConfirmMessage('');
        modalContext.setConfirmAction(null);
        modalContext.setConfirmLabel('');
        modalContext.setConfirmVariant('');
    };

    const label = modalContext.confirmLabel || 'Delete';
    const isPrimary = modalContext.confirmVariant === 'primary';

    return (
        <div className="modal-overlay confirm-overlay" onClick={handleCancel}>
            <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-body">
                    <div className="confirm-message">
                        {modalContext.confirmMessage}
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        className="cancel-btn"
                        onClick={handleCancel}
                        disabled={isExecuting}
                    >
                        Cancel
                    </button>
                    <button
                        className={`confirm-btn ${isPrimary ? 'confirm-btn--primary' : ''}`}
                        onClick={handleConfirm}
                        disabled={isExecuting}
                    >
                        {isExecuting ? 'Please wait...' : label}
                    </button>
                </div>
            </div>
        </div>
    );
}
